import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { BackgroundTexture } from "../components/BackgroundTexture";
import { EventCardGrid } from "../components/EventCardGrid";
import { Footer } from "../components/Footer";

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    Promise.all([api.getEvents(), api.getSettings()])
      .then(([e, s]) => { setEvents(e.data); setSettings(s.data); })
      .catch(console.error);
  }, []);

  return (
    <div data-testid="events-page" className="min-h-screen content-layer">
      <BackgroundTexture />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-8 lg:py-12 relative z-10">
        <div className="mb-8">
          <p className="text-[11px] font-medium tracking-[0.15em] text-white/60 uppercase mb-2">Calendar</p>
          <h1 className="font-syne text-3xl lg:text-4xl font-semibold text-white">All Events</h1>
        </div>

        {events.length === 0 ? (
          <p className="text-white/60 py-20 text-center">No events scheduled. Check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {events.map((event) => (
              <EventCardGrid key={event.id} event={event} />
            ))}
          </div>
        )}
      </div>
      <Footer settings={settings} />
    </div>
  );
}
